'use client'
import FreeUserFilterModal from '@/components/FreeUserFilterModal'
import CompanyFilter from './CompanyFilter'
import { useFreeUserValidation } from '@/app/hooks/useFreeUserValidation'

const SwitchCompanyFilter = ({ search }: { search: string }) => {
  const { isModalApplicable } = useFreeUserValidation()

  return (
    <div>
      <div className="w-[299px] mobile:w-[360px]" suppressHydrationWarning>
        {isModalApplicable() && (
          <FreeUserFilterModal
            display="Go back to Home"
            to="/"
            search={search}
            retailCompanyResponse={undefined}
          />
        )}
        <div
          className={`${isModalApplicable() ? 'cursor-not-allowed pointer-events-none opacity-50' : ''}`}
        >
          <CompanyFilter search={search} />
        </div>
      </div>
    </div>
  )
}
export default SwitchCompanyFilter
